import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/DashboardSidebar';
import './AddProduct.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://orders.fletaime.com';

export default function Discounts() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);

  const [enabled, setEnabled] = useState(true);
  const [percent, setPercent] = useState(10);

  useEffect(() => {
    if (localStorage.getItem('dashboardAuth') !== 'true') {
      navigate('/dashboard/sign-in');
      return;
    }
    fetch(`${API_URL}/api/settings`)
      .then(r => r.json())
      .then(data => {
        if (data && !data.error) {
          setEnabled(!!data.online_discount_enabled);
          setPercent(data.online_discount_percent ?? 10);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [navigate]);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSaved(false);
    try {
      const res = await fetch(`${API_URL}/api/settings`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          online_discount_enabled: enabled,
          online_discount_percent: percent,
        }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Gabim gjatë ruajtjes.'); setSaving(false); return; }
      setSaved(true);
    } catch {
      setError('Gabim gjatë lidhjes me serverin.');
    }
    setSaving(false);
  };

  if (loading) return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="dashboard-content"><div className="pa-loading">Duke ngarkuar...</div></div>
    </div>
  );

  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="dashboard-content">
        <div className="ap-header">
          <h2>Zbritjet</h2>
        </div>

        <form className="ap-form" onSubmit={handleSave} style={{ maxWidth: 480 }}>
          {error && <div className="ap-error">{error}</div>}
          {saved && !error && (
            <div style={{ background: '#e6f9ee', color: '#1a7a43', padding: '10px 14px', borderRadius: 8, fontSize: 14 }}>
              U ruajt me sukses.
            </div>
          )}

          <div className="ap-field ap-checkbox-field">
            <label>
              <input
                type="checkbox"
                checked={enabled}
                onChange={e => { setEnabled(e.target.checked); setSaved(false); }}
              />
              {' '}Zbritje për pagesë online (aktive)
            </label>
          </div>

          <div className="ap-field">
            <label>Zbritja (%)</label>
            <input
              type="number"
              min="0"
              max="100"
              step="1"
              value={percent}
              onChange={e => { setPercent(e.target.value); setSaved(false); }}
              disabled={!enabled}
            />
          </div>

          <p style={{ fontSize: 13, color: '#666' }}>
            Kur është aktive, klientët që zgjedhin "Paguaj online" te faqja e porosisë marrin këtë zbritje automatikisht, e llogaritur mbi çmimin e produktit.
          </p>

          <div className="ap-actions">
            <button type="submit" className="ap-btn-save" disabled={saving}>
              {saving ? 'Duke ruajtur...' : 'Ruaj'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
